export enum TabEnum {
    EINZELABFRAGE = 'einzelabfrage',
    VERAENDERUNGSMITTEILUNG = 'veraenderungsmitteilung',
}
